import { useEffect, useState } from 'react';

/**
 * The time, refreshed once a minute while mounted, so "3 min ago" keeps
 * telling the truth on an open panel. A plain re-render, nothing animates.
 */
export function useNow(everyMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = window.setInterval(() => setNow(new Date()), everyMs);
    return () => window.clearInterval(t);
  }, [everyMs]);
  return now;
}
